import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import SimpleViewLayout from '@/layout/SimpleViewLayout'
import PortalLayout from '@/layout/PortalLayout'
import store from './store.js';


Vue.use(Router)

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  beforeEach: (to, from, next) => {
    // // redirect to login page if not logged in and trying to access a restricted page
    // const publicPages = ['/login', '/register'];
    // const authRequired = !publicPages.includes(to.path);
    // const loggedIn = localStorage.getItem('user');

    // if (authRequired && !loggedIn) {
    //   return next('/login');
    // }

    // next();

    alert('asd');
  },
  routes: [
    {
      path: '/dashboard',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
        },
        {
          path: '/pagos',
          name: 'pagos',
          component: () => import(/* webpackChunkName: "demo" */ './views/Pagos.vue')
        },
        {
          path: '/solicitudes',
          name: 'solicitudes de transferencia',
          component: () => import(/* webpackChunkName: "demo" */ './views/Solicitudes.vue')
        },
        {
          path: '/bancos',
          name: 'bancos',
          component: () => import(/* webpackChunkName: "demo" */ './views/Banks.vue')
        },
        {
          path: '/agregarModificarBanco',
          name: 'agregarModificarBanco',
          component: () => import(/* webpackChunkName: "demo" */ './views/AddUpdateBank.vue'),
          props: true
        },
        {
          path: '/nuevatransferencia',
          name: 'nuevatransferencia',
          component: () => import(/* webpackChunkName: "demo" */ './views/NuevaTransferencia.vue')
        },
        {
          path: '/enviardinero',
          name: 'enviar dinero',
          component: () => import(/* webpackChunkName: "demo" */ './views/EnviarDinero.vue'),
          props: true
        },
        {
          path: '/TransferenciasCVUCBU',
          name: 'TransferenciasCVUCBU',
          component: () => import(/* webpackChunkName: "demo" */ './views/TransferenciasCVUCBU.vue')
        },
        {
          path: '/ConfirmarDatosTransferenciaCVUCBU',
          name: 'ConfirmarDatosTransferenciaCVUCBU',
          component: () => import(/* webpackChunkName: "demo" */ './views/ConfirmarDatosTransferenciaCVUCBU.vue'),
          props: true
        },
        {
          path: '/TransferAmount',
          name: 'TransferAmount',
          component: () => import(/* webpackChunkName: "demo" */ './views/TransferAmount.vue'),
          props: true
        },
        {
          path: '/solicitardinero',
          name: 'solicitar dinero',
          component: () => import(/* webpackChunkName: "demo" */ './views/SolicitarDinero.vue')
        },
        {
          path: '/pagocomercio',
          name: 'pago en comercio',
          component: () => import(/* webpackChunkName: "demo" */ './views/PagoComercio.vue')
        },
        {
          path: '/solicitudesdinero',
          name: 'solicitudes de dinero',
          component: () => import(/* webpackChunkName: "demo" */ './views/SolicitudesDinero.vue')
        },
        {
          path: '/MiQR',
          name: 'miQR',
          component: () => import(/* webpackChunkName: "demo" */ './views/MiQR.vue')
        },
        {
          path: '/recarga',
          name: 'recarga',
          component: () => import(/* webpackChunkName: "demo" */ './views/Recarga.vue')
        },
        {
          path: '/SmartPost',
          name: 'SmartPost',
          component: () => import(/* webpackChunkName: "demo" */ './views/SmartPost.vue')
        },
        {
          path: '/InformacionComisionesFintouch',
          name: 'InformacionComisionesFintouch',
          component: () => import(/* webpackChunkName: "demo" */ './views/InformacionComisionesFintouch.vue')
        },
        {
          path: '/MisDispositivos',
          name: 'MisDispositivos',
          component: () => import(/* webpackChunkName: "demo" */ './views/MisDispositivos.vue')
        },
        {
          path: '/AgregarDispositivo',
          name: 'AgregarDispositivo',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgregarDispositivo.vue'),
          props: true
        },
        {
          path: '/AcreditacionesPendientes',
          name: 'AcreditacionesPendientes',
          component: () => import(/* webpackChunkName: "demo" */ './views/AcreditacionesPendientes.vue')
        },
        {
          path: '/ListadoOperaciones',
          name: 'ListadoOperaciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/ListadoOperaciones.vue')
        },
        {
          path: '/ListadoAcreditaciones',
          name: 'ListadoAcreditaciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/ListadoAcreditaciones.vue')
        },
        {
          path: '/CalendarioAcreditaciones',
          name: 'CalendarioAcreditaciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/CalendarioAcreditaciones.vue')
        },
        {
          path: '/ConfiguracionCostos',
          name: 'ConfiguracionCostos',
          component: () => import(/* webpackChunkName: "demo" */ './views/ConfiguracionCostos.vue')
        },
        {
          path: '/SmartPostConfiguration',
          name: 'SmartPostConfiguration',
          component: () => import(/* webpackChunkName: "demo" */ './views/SmartPostConfiguration.vue')
        },
        {
          path: '/CodigoQRConfiguration',
          name: 'CodigoQRConfiguration',
          component: () => import(/* webpackChunkName: "demo" */ './views/CodigoQRConfiguration.vue')
        },
        {
          path: '/LinkDePagoConfiguration',
          name: 'LinkDePagoConfiguration',
          component: () => import(/* webpackChunkName: "demo" */ './views/LinkDePagoConfiguration.vue')
        },
        {
          path: '/estacionar',
          name: 'estacionar',
          component: () => import(/* webpackChunkName: "demo" */ './views/Estacionar.vue'),
          props: true
        },
        {
          path: '/vermovimientos',
          name: 'ver movimientos',
          component: () => import(/* webpackChunkName: "demo" */ './views/VerMovimientos.vue')
        },
        {
          path: '/vermovimientosdetallado',
          name: 'ver movimientos detallado',
          component: () => import(/* webpackChunkName: "demo" */ './views/VerMovimientosDetallado.vue')
        },
        {
          path: '/miscomprobantes',
          name: 'mis comprobantes',
          component: () => import(/* webpackChunkName: "demo" */ './views/MisComprobantes.vue')
        },
        {
          path: '/pagofactura',
          name: 'pago facturas',
          component: () => import(/* webpackChunkName: "demo" */ './views/CobroFacturas.vue')
        },
        // {
        //   path: '/cargartarjeta',
        //   name: 'cargar tarjeta',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/CargarTarjeta.vue')
        // },
        {
          path: '/miperfilp',
          name: 'mis datos',
          component: () => import(/* webpackChunkName: "demo" */ './views/MiPerfilPersona.vue')
        },
        {
          path: '/claveretiro',
          name: 'clave retiro',
          component: () => import(/* webpackChunkName: "demo" */ './views/ClaveRetiro.vue')
        },
        {
          path: '/misimagenes',
          name: 'mis imagenes',
          component: () => import(/* webpackChunkName: "demo" */ './views/MisImagenes.vue')
        },
        {
          path: '/miperfilc',
          name: 'mis datos',
          component: () => import(/* webpackChunkName: "demo" */ './views/MiPerfilComercio.vue')
        },
        {
          path: '/pagoproveedor',
          name: 'pago proveedor',
          component: () => import(/* webpackChunkName: "demo" */ './views/PagoProveedor.vue')
        },
        {
          path: '/gestionproveedores',
          name: 'gestion proveedores',
          component: () => import(/* webpackChunkName: "demo" */ './views/GestionProveedores.vue')
        },
        {
          path: '/micvu',
          name: 'mi cvu',
          component: () => import(/* webpackChunkName: "demo" */ './views/MiCVU.vue')
        },
        {
          path: '/MyPrepaidCard',
          name: 'MyPrepaidCard',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MyPrepaidCard.vue'),
          props: true
        },
        {
          path: '/RequestMyCard',
          name: 'request my card',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/RequestMyCard.vue')
        },
        {
          path: '/GenerateCard',
          name: 'generate card',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/GenerateCard.vue')
        },
        {
          path: '/ConfirmAddress',
          name: 'confirm address',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ConfirmAddress.vue')
        },
        {
          path: '/AddAnotherAddress',
          name: 'add another address',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/AddAnotherAddress.vue')
        },
        {
          path: '/WhereWeDeliverTheCard',
          name: 'where we deilver the card',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/WhereWeDeliverTheCard.vue')
        },
        {
          path: '/FinishCardGeneration',
          name: 'finish card generation',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/FinishCardGeneration.vue')
        },
        {
          path: '/CardRequestGenerated',
          name: 'CardRequestGenerated',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/CardRequestGenerated.vue'),
          props: true
        },
        {
          path: '/CardGenerationRequestApproved',
          name: 'card generation request approved',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/CardGenerationRequestApproved.vue')
        },
        {
          path: '/CardGenerationRequestRefused',
          name: 'card generation request refused',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/CardGenerationRequestRefused.vue'),
          props: true
        },
        {
          path: '/ApprovedCardTracking',
          name: 'ApprovedCardTracking',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ApprovedCardTracking.vue'),
          props: true
        },
        {
          path: '/ActivateMyCard',
          name: 'ActivateMyCard',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ActivateMyCard.vue')
        },
        {
          path: '/RenaperInfo',
          name: 'RenaperInfo',
          component: () => import(/* webpackChunkName: "demo" */ './views/RenaperInfo.vue')
        },
        {
          path: '/EnviarDineroNew',
          name: 'EnviarDineroNew',
          component: () => import(/* webpackChunkName: "demo" */ './views/EnviarDineroNew.vue')
        },
        {
          path: '/MiTarjetaPrepaga',
          name: 'MiTarjetaPrepaga',
          component: () => import(/* webpackChunkName: "demo" */ './views/MiTarjetaPrepaga.vue')
        },
        {
          path: '/cambiarpassword',
          name: 'cambiar password',
          component: () => import(/* webpackChunkName: "demo" */ './views/CambiarPassword.vue')
        },
        {
          path: '/mapacomercios',
          name: 'mapa comercios',
          component: () => import(/* webpackChunkName: "demo" */ './views/MapaComercio.vue')
        },
        {
          path: '/ayuda',
          name: 'ayuda',
          component: () => import(/* webpackChunkName: "demo" */ './views/Reclamos.vue')
        },
        // {
        //   path: '/datosvisibles',
        //   name: 'datos visibles',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/DatosVisibles.vue')
        // },
        {
          path: '/sucursales',
          name: 'sucursales',
          component: () => import(/* webpackChunkName: "demo" */ './views/Sucursales.vue')
        },
        {
          path: '/administrarcajas',
          name: 'administrarcajas',
          component: () => import(/* webpackChunkName: "demo" */ './views/AdministrarCajas.vue'),
          props: true
        },
        {
          path: '/crearsucursal',
          name: 'crearsucursal',
          component: () => import(/* webpackChunkName: "demo" */ './views/CrearSucursal.vue'),
          props: true
        },
        {
          path: '/cajeros',
          name: 'cajeros',
          component: () => import(/* webpackChunkName: "demo" */ './views/Cajeros.vue'),
          props: true
        },
        {
          path: '/crearcajero',
          name: 'crearcajero',
          component: () => import(/* webpackChunkName: "demo" */ './views/CrearCajero.vue'),
          props: true
        },
        {
          path: '/supervisores',
          name: 'supervisores',
          component: () => import(/* webpackChunkName: "demo" */ './views/Supervisores.vue'),
          props: true
        },
        {
          path: '/crearsupervisor',
          name: 'crearsupervisor',
          component: () => import(/* webpackChunkName: "demo" */ './views/CrearSupervisor.vue'),
          props: true
        },
        {
          path: '/cajasactivas',
          name: 'cajasactivas',
          component: () => import(/* webpackChunkName: "demo" */ './views/CajasActivas.vue'),
          props: true
        },
        {
          path: '/cobrarconqr',
          name: 'cobrarconqr',
          component: () => import(/* webpackChunkName: "demo" */ './views/ChargeWithQR.vue')
        },
        {
          path: '/Logout',
          name: 'Logout',
          component: () => import(/* webpackChunkName: "demo" */ './views/Logout.vue')
        },
        {
          path: '/updatealiascvu',
          name: 'updatealiascvu',
          component: () => import(/* webpackChunkName: "demo" */ './views/UpdateAliasCVU.vue'),
          props: true
        },
        {
          path: '/faqs',
          name: 'faqs',
          component: () => import(/* webpackChunkName: "demo" */ './views/Help.vue')
        },
        {
          path: '/pin',
          name: 'pin',
          component: () => import(/* webpackChunkName: "demo" */ './views/Pin/PinActivation.vue')
        },
        {
          path: '/pinconfiguration',
          name: 'pinconfiguration',
          component: () => import(/* webpackChunkName: "demo" */ './views/Pin/PinConfiguration.vue'),
          props: true
        },
        {
          path: '/configuration',
          name: 'configuration',
          component: () => import(/* webpackChunkName: "demo" */ './views/Configuration.vue'),
          props: true
        },
        {
          path: '/pagocondni',
          name: 'pagocondni',
          component: () => import(/* webpackChunkName: "demo" */ './views/PagoConDNI.vue')
        },
        {
          path: '/MyMastercardWallet',
          name: 'MyMastercardWallet',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MyMastercardWallet.vue'),
          props: true
        },
        {
          path: '/CardMovements',
          name: 'CardMovements',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/CardMovements.vue')
        },
        {
          path: '/ChargeCardBalance',
          name: 'ChargeCardBalance',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ChargeCardBalance.vue')
        },
        {
          path: '/ReverseLastCharge',
          name: 'ReverseLastCharge',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ReverseLastCharge.vue')
        },
        {
          path: '/RequestLock',
          name: 'RequestLock',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/RequestLock.vue')
        },
        {
          path: '/RequestUnsubscribe',
          name: 'RequestUnsubscribe',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/RequestUnsubscribe.vue')
        },
        {
          path: '/AgendaDestinatarios',
          name: 'AgendaDestinatarios',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgendaDestinatarios.vue')
        },
        {
          path: '/NuevoDestinatario',
          name: 'NuevoDestinatario',
          component: () => import(/* webpackChunkName: "demo" */ './views/NuevoDestinatario.vue')
        },
        {
          path: '/ConfirmarNuevoDestinatario',
          name: 'ConfirmarNuevoDestinatario',
          component: () => import(/* webpackChunkName: "demo" */ './views/ConfirmarNuevoDestinatario.vue'),
          props: true
        },
        {
          path: '/MastercardAccountDisable',
          name: 'MastercardAccountDisable',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MastercardAccountDisable.vue')
        },
        {
          path: '/ImpuestoMovimientoMastercard',
          name: 'ImpuestoMovimientoMastercard',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ImpuestoMovimientoMastercard.vue'),
          props: true
        },
        {
          path: '/miprestamo',
          name: 'miprestamo',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MyLoan.vue')
        },
        {
          path: '/miprestamorechazado',
          name: 'miprestamorechazado',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MyLoanRejected.vue')
        },
        {
          path: '/misprestamos',
          name: 'misprestamos',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MyPersonalLoans.vue')
        },
        {
          path: '/miprestamoPersonal',
          name: 'miprestamoPersonal',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MyPersonalLoan.vue'),
          props: true
        },
        {
          path: '/solicitudPendiente',
          name: 'solicitudPendiente',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/SolicitudPendiente.vue'),
          props: true
        },
        {
          path: '/ReprintCard',
          name: 'ReprintCard',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/ReprintCard.vue')
        },
        {
          path: '/MastercardCashout',
          name: 'MastercardCashout',
          component: () => import(/* webpackChunkName: "demo" */ './views/Mastercard/MastercardCashout.vue')
        },
        {
          path: '/verificacionidentidad',
          name: 'verificacion de identidad',
          component: () => import(/* webpackChunkName: "demo" */ './views/IdentityValidation.vue'),
          props: { showAcceptButton: false }
        },
        {
          path: '/verificaciondospasos',
          name: 'verificacion de identidad en dos pasos',
          component: () => import(/* webpackChunkName: "demo" */ './views/IdentityValidationTwoSteps.vue'),
          props: true
        },
        {
          path: '/selectSecurityMethod',
          name: 'selectSecurityMethod',
          component: () => import(/* webpackChunkName: "demo" */ './views/SelectSecurityMethod.vue'),
          props: true
        },
        {
          path: '/validateSecurityCode',
          name: 'validateSecurityCode',
          component: () => import(/* webpackChunkName: "demo" */ './views/ValidateSecurityCode.vue'),
          props: true
        },
        {
          path: '/resultPage',
          name: 'resultPage',
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard/ResultPage.vue'),
          props: true
        },
        {
          path: '/EmailValidation',
          name: 'EmailValidation',
          component: () => import(/* webpackChunkName: "demo" */ './views/EmailValidation.vue'),
          props: true
        },
        {
          path: '/EmailModification',
          name: 'EmailModification',
          component: () => import(/* webpackChunkName: "demo" */ './views/EmailModification.vue'),
          props: true
        },
        {
          path: '/PhoneValidation',
          name: 'PhoneValidation',
          component: () => import(/* webpackChunkName: "demo" */ './views/PhoneValidation.vue'),
          props: true
        },
        {
          path: '/PhoneModification',
          name: 'PhoneModification',
          component: () => import(/* webpackChunkName: "demo" */ './views/PhoneModification.vue'),
          props: true
        },
        {
          path: '/MisCuentas',
          name: 'MisCuentas',
          component: () => import(/* webpackChunkName: "demo" */ './views/MisCuentas.vue'),
        },
        {
          path: '/AgregarCuenta',
          name: 'AgregarCuenta',
          component: () => import(/* webpackChunkName: "demo" */ './views/AgregarCuenta.vue'),
        },
        {
          path: '/IngresarDinero',
          name: 'IngresarDinero',
          component: () => import(/* webpackChunkName: "demo" */ './views/IngresarDinero.vue'),
          props: true
        },
        {
          path: '/AdministrarCuenta',
          name: 'AdministrarCuenta',
          component: () => import(/* webpackChunkName: "demo" */ './views/AdministrarCuenta.vue'),
          props: true
        },
        {
          path: '/EliminarPSP',
          name: 'EliminarPSP',
          component: () => import(/* webpackChunkName: "demo" */ './views/EliminarPSP.vue'),
          props: true
        },
        {
          path: '/Operaciones',
          name: 'Operaciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/Operaciones.vue')
        },
        {
          path: '/ConfigurarPlazosAcreditacion',
          name: 'ConfigurarPlazosAcreditacion',
          component: () => import(/* webpackChunkName: "demo" */ './views/ConfigurarPlazosAcreditacion.vue')
        },
        {
          path: '/DispositivosVinculados',
          name: 'DispositivosVinculados',
          component: () => import(/* webpackChunkName: "demo" */ './views/DispositivosVinculados.vue')
        },
        {
          path: '/ReporteOperacionesSearchDates',
          name: 'ReporteOperacionesSearchDates',
          component: () => import(/* webpackChunkName: "demo" */ './views/ReporteOperacionesSearchDates.vue')
        },
        {
          path: '/ReporteOperaciones',
          name: 'ReporteOperaciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/ReporteOperaciones.vue'),
          props: true
        },
        {
          path: '/ReporteImpuestosSearchDates',
          name: 'ReporteImpuestosSearchDates',
          component: () => import(/* webpackChunkName: "demo" */ './views/ReporteImpuestosSearchDates.vue')
        },
        {
          path: '/ReporteImpuestos',
          name: 'ReporteImpuestos',
          component: () => import(/* webpackChunkName: "demo" */ './views/ReporteImpuestos.vue'),
          props: true
        },
        {
          path: '/MisReportes',
          name: 'MisReportes',
          component: () => import(/* webpackChunkName: "demo" */ './views/MisReportes.vue')
        },
        {
          path: '/OtrasOpciones',
          name: 'OtrasOpciones',
          component: () => import(/* webpackChunkName: "demo" */ './views/OtrasOpciones.vue')
        },
        {
          path: '/DebinSpot',
          name: 'DebinSpot',
          component: () => import(/* webpackChunkName: "demo" */ './views/DebinSpot.vue')
        },
        {
          path: '/OtrasOpcionesRecurrencias',
          name: 'OtrasOpcionesRecurrencias',
          component: () => import(/* webpackChunkName: "demo" */ './views/OtrasOpcionesRecurrencias.vue')
        },
        {
          path: '/Recurrencias',
          name: 'Recurrencias',
          component: () => import(/* webpackChunkName: "demo" */ './views/Recurrencias.vue')
        },
        {
          path: '/DebinRecurrente',
          name: 'DebinRecurrente',
          component: () => import(/* webpackChunkName: "demo" */ './views/DebinRecurrente.vue')
        },
        {
          path: '/OtrasOpcionesRecurrenciasDebinProgramado',
          name: 'OtrasOpcionesRecurrenciasDebinProgramado',
          component: () => import(/* webpackChunkName: "demo" */ './views/OtrasOpcionesRecurrenciasDebinProgramado.vue')
        },
        {
          path: '/RecurrenciasDebinProgramado',
          name: 'RecurrenciasDebinProgramado',
          component: () => import(/* webpackChunkName: "demo" */ './views/RecurrenciasDebinProgramado.vue')
        },
        {
          path: '/DebinRecurrenteDebinProgramado',
          name: 'DebinRecurrenteDebinProgramado',
          component: () => import(/* webpackChunkName: "demo" */ './views/DebinRecurrenteDebinProgramado.vue')
        },
      ]
    },
    {
      path: '/login',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue')
        },
        {
          path: '/registro',
          name: 'registro',
          component: () => import(/* webpackChunkName: "demo" */ './views/Registro.vue')
        },
        {
          path: '/validateEmail',
          name: 'validateemail',
          component: () => import(/* webpackChunkName: "demo" */ './views/ValidateEmail.vue')
        },
        {
          path: '/autorizacion/responder',
          name: 'autorizacionComercioAsociadoRespuesta',
          component: () => import(/* webpackChunkName: "demo" */ './views/AutorizacionComercioAsociadoRespuesta.vue')
        },
        {
          path: '/comercioasociado/recoverypassword',
          name: 'recoveryPasswordComercioAsociado',
          component: () => import(/* webpackChunkName: "demo" */ './views/RecoveryPasswordComercioAsociado.vue')
        },
        {
          path: '/associatedevice',
          name: 'associatedevice',
          component: () => import(/* webpackChunkName: "demo" */ './views/AssociateDevice.vue')
        },
        {
          path: '/recoverypassword',
          name: 'recoverypassword',
          component: () => import(/* webpackChunkName: "demo" */ './views/RecoveryPassword.vue')
        },
        {
          path: '/logincajero',
          name: 'logincajero',
          component: () => import(/* webpackChunkName: "demo" */ './views/LoginCajero.vue')
        },
        {
          path: '/emailvalidationform',
          name: 'emailvalidationform',
          component: () => import(/* webpackChunkName: "demo" */ './views/EmailValidationForm.vue')
        },
        {
          path: '/verificacionidentidadlogin',
          name: 'verificacionidentidadlogin',
          component: () => import(/* webpackChunkName: "demo" */ './views/IdentityValidation.vue'),
          props: true
        },
        {
          path: '/InitialPhoneValidation',
          name: 'InitialPhoneValidation',
          component: () => import(/* webpackChunkName: "demo" */ './views/InitialConfiguration/InitialPhoneValidation.vue'),
          props: true
        },
        {
          path: '/InitialPinConfiguration',
          name: 'InitialPinConfiguration',
          component: () => import(/* webpackChunkName: "demo" */ './views/InitialConfiguration/InitialPinConfiguration.vue'),
          props: true
        },
        {
          path: '/InitialIdentityValidationTwoSteps',
          name: 'InitialIdentityValidationTwoSteps',
          component: () => import(/* webpackChunkName: "demo" */ './views/InitialConfiguration/InitialIdentityValidationTwoSteps.vue'),
          props: true
        },
        {
          path: '/InitialSelectSecurityMethod',
          name: 'InitialSelectSecurityMethod',
          component: () => import(/* webpackChunkName: "demo" */ './views/InitialConfiguration/InitialSelectSecurityMethod.vue'),
          props: true
        },
        {
          path: '/InitialValidateSecurityCode',
          name: 'InitialValidateSecurityCode',
          component: () => import(/* webpackChunkName: "demo" */ './views/ValidateSecurityCode.vue'),
          props: true
        },
        {
          path: '/loginchangepassword',
          name: 'cambiar password login',
          component: () => import(/* webpackChunkName: "demo" */ './views/InitialConfiguration/InitialCambiarPassword.vue')
        },
        {
          path: '/NuevoInicioSesion',
          name: 'NuevoInicioSesion',
          component: () => import(/* webpackChunkName: "demo" */ './views/NuevoInicioSesion.vue'),
          props: true
        },
        {
          path: '/InitialAcceptTermsAndConditions',
          name: 'InitialAcceptTermsAndConditions',
          component: () => import(/* webpackChunkName: "demo" */ './views/InitialConfiguration/InitialAcceptTermsAndConditions.vue')
        },
      ]
    },
    {
      path: '/tarjeta',
      redirect: '/tarjeta',
      component: SimpleViewLayout,
      children: [
        {
          path: '/tarjeta',
          name: 'tarjeta',
          component: () => import(/* webpackChunkName: "demo" */ './views/RecargarConTarjeta.vue')
        },
        {
          path: '/',
          name: 'Home',
          component: () => import(/* webpackChunkName: "demo" */ './views/HomeInstitucional.vue')
        },
        {
          path: '/Invitar',
          name: 'Tarjeta',
          component: () => import(/* webpackChunkName: "demo" */ './views/Invitar.vue')
        },
        {
          path: '/legales',
          name: 'legales',
          component: () => import(/* webpackChunkName: "demo" */ './views/Legales.vue')
        },
        {
          path: '/redirect',
          name: 'redirect',
          component: () => import(/* webpackChunkName: "demo" */ './views/Redirect.vue')
        },
        {
          path: '/enrollment',
          name: 'enrollment',
          component: () => import(/* webpackChunkName: "demo" */ './views/Enrollment.vue')
        }]
    },
    {
      path: '/',
      redirect: '/',
      component: PortalLayout,
      children: [
        {
          path: '/',
          name: 'Home',
          component: () => import(/* webpackChunkName: "demo" */ './views/HomeInstitucional.vue')
        },
        {
          path: '/empresas',
          name: 'empresas',
          component: () => import(/* webpackChunkName: "demo" */ './views/Empresas.vue'),
          props: true
        }]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/registro', '/validateemail', '/tarjeta', '/recoverypassword', '/comercioasociado/recoverypassword', '/', '/Invitar', '/legales', '/logincajero', '/empresas', '/emailvalidationform', '/redirect', '/enrollment', '/associatedevice', '/autorizacion/responder'];
  const authRequired = !publicPages.includes(to.path);
  // -- Si se requiere login y no esta logueado

  if (authRequired && !store.getters.isLogged) {
    return next('/login');
  }
  //else if (store.getters.isLogged && !store.getters.identityWasVerificated && to.path != '/verificacionidentidadlogin') {
  //return next({name:'verificacionidentidadlogin',params:{showAcceptButton : true}}); 
  //} 
  else if (authRequired && store.getters.isLogged) {
    const basePaths = ["/", "/dashboard", "/login", '/logincajero', '/registro', '/empresas', '/legales', '/updatealiascvu', '/validateemail', '/emailvalidationform', '/verificacionidentidadlogin', '/verificaciondospasos', '/SecurityMethodsSelection', '/loginchangepassword', '/InitialPinConfiguration', '/InitialPhoneValidation', '/InitialIdentityValidationTwoSteps', '/InitialSelectSecurityMethod', '/InitialValidateSecurityCode', '/NuevoInicioSesion'];

    //Formularios entre el login y dashboard

    // * LOGIN
    // VALIDAR EMAIL
    // VERIFICACIÓN DE IDENTIDAD
    // CAMBIO DE CONTRASEÑA
    // VERIFICAR NUEVO DISPOSITIVO
    // TERMINOS Y CONDICIONES ACEPTADOS
    // PIN
    // VALIDAR TELÉFONO
    // DOBLE FACTOR
    // * INICIO EN LA HOME

    // Para deslogear cuando se ingresa el path del login en el navegador
    var loginPath = '/login';
    if (to.path == loginPath && from.path == '/') {
      store.dispatch("logout").then(() => {
        return next(loginPath);
      });
    }

    // Agregamos '/InitialSelectSecurityMethod', '/InitialValidateSecurityCode' para que no entre en otra ruta ya que son paginas de validacion intermedias (no de inicio)
    var pathsBetweenLoginAndDashboard = ['/InitialSelectSecurityMethod', '/InitialValidateSecurityCode'];
    var pathBetweenLoginAndDashboard = '';

    // VALIDAR EMAIL
    pathBetweenLoginAndDashboard = "/emailvalidationform";
    pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
    if (!store.getters.IsMailVerify && !store.getters.isAssociatedCommerce && !pathsBetweenLoginAndDashboard.includes(to.path)) {
      return next(pathBetweenLoginAndDashboard);
    }

    // VERIFICACIÓN DE IDENTIDAD
    pathBetweenLoginAndDashboard = "/verificacionidentidadlogin";
    pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
    if (!store.getters.identityWasVerificated && !store.getters.isCashier && !store.getters.isAccountTypeSupervisor && !pathsBetweenLoginAndDashboard.includes(to.path)) {
      return next({ name: 'verificacionidentidadlogin', params: { showAcceptButton: true } });
    }

    if (store.getters.ShouldPerformTwoStepVerification) {
      // CAMBIO DE CONTRASEÑA
      pathBetweenLoginAndDashboard = "/loginchangepassword";
      pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
      if (store.getters.userChangePassword && !pathsBetweenLoginAndDashboard.includes(to.path)) {
        return next(pathBetweenLoginAndDashboard);
      }

      // VERIFICAR NUEVO DISPOSITIVO (NuevoInicioSesion)
      pathBetweenLoginAndDashboard = "/NuevoInicioSesion";
      pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
      if (store.getters.NewDevice && !store.getters.isCashier && !store.getters.isAccountTypeSupervisor && !pathsBetweenLoginAndDashboard.includes(to.path)) {
        return next(pathBetweenLoginAndDashboard);
      }

      // TERMINOS Y CONDICIONES ACEPTADOS
      pathBetweenLoginAndDashboard = "/InitialAcceptTermsAndConditions";
      pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
      if (!store.getters.TermsAndConditionsAccepted && !store.getters.isCashier && !store.getters.isAccountTypeSupervisor && !pathsBetweenLoginAndDashboard.includes(to.path)) {
        return next(pathBetweenLoginAndDashboard);
      }

      // PIN
      pathBetweenLoginAndDashboard = "/InitialPinConfiguration";
      pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
      if (!store.getters.UsePaymentPin && !store.getters.isCashier && !store.getters.isAccountTypeSupervisor && !pathsBetweenLoginAndDashboard.includes(to.path)) {
        return next(pathBetweenLoginAndDashboard);
      }

      // VALIDAR TELÉFONO
      pathBetweenLoginAndDashboard = "/InitialPhoneValidation";
      pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
      if (!store.getters.IsPhoneVerify && !store.getters.isCashier && !store.getters.isAccountTypeSupervisor && !pathsBetweenLoginAndDashboard.includes(to.path)) {
        return next(pathBetweenLoginAndDashboard);
      }

      // DOBLE FACTOR
      pathBetweenLoginAndDashboard = "/InitialIdentityValidationTwoSteps";
      pathsBetweenLoginAndDashboard.push(pathBetweenLoginAndDashboard)
      if (!store.getters.TwoStepVerification && !store.getters.isCashier && !store.getters.isAccountTypeSupervisor && !pathsBetweenLoginAndDashboard.includes(to.path)) {
        return next(pathBetweenLoginAndDashboard);
      }
    }

    if (!basePaths.includes(to.path) && !pathsBetweenLoginAndDashboard.includes(to.path) && !store.getters.ModuleActionList.includes(to.path) && from.path != '/') {
      return next("/dashboard");
    }
  }
  // -- Evitamos cacheo con meta tags
  let tags = [];
  tags.push({ 'http-equiv': 'cache-control', content: 'max-age=0' });
  tags.push({ 'http-equiv': 'cache-control', content: 'no-cache' });
  tags.push({ 'http-equiv': 'expires', content: '0' });
  tags.push({ 'http-equiv': 'expires', content: 'Tue, 01 Jan 1980 1:00:00 GMT' });
  tags.push({ 'http-equiv': 'pragma', content: 'no-cache' });

  // Turn the meta tag definitions into actual elements in the head.
  tags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  window.scrollTo(0, 0);

  next();
})

export default router